var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.465,
    height: 14.999,
    viewBox: "0 0 17.465 14.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4592",
    "data-name": "Path 4592",
    d: "M17.465-7.5a.938.938,0,0,1-.938.938H3.277L8.461-1.617A.936.936,0,0,1,8.493-.291a.939.939,0,0,1-1.326.032L.292-6.822A.927.927,0,0,1,0-7.5a.942.942,0,0,1,.291-.68l6.875-6.562a.941.941,0,0,1,1.326.033.937.937,0,0,1-.032,1.326L3.277-8.438H16.562A.911.911,0,0,1,17.465-7.5Z",
    transform: "translate(0 15)",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.c4c7137946d92ff1f3e3136454370daa.svg";
export { ForwardRef as ReactComponent };